import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroGuarantees } from '../data/content';
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-12 pt-4 sm:pb-20 sm:pt-10" style={{
    paddingTop: '15px'
  }} data-id="element-128" data-mp="ei1unjxvvyww">
      <div className="mx-auto max-w-4xl text-center" data-id="element-129" data-mp="4m8nyh6uizn1">
        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-[11px] font-bold uppercase leading-tight tracking-[0.18em] text-teal sm:text-xs sm:tracking-[0.22em]" data-id="element-130" data-mp="4njpsbgqdxbi">
          Il curriculum di musica completo per docenti italiani
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: 'easeOut'
      }} className="mt-3 font-display text-[2.25rem] font-black leading-[1.06] tracking-tight text-navy sm:mt-5 sm:text-[3.4rem] md:text-[4rem]" data-id="element-131" data-mp="nbf0tnkykx0x">
          Risolvi un Intero Anno di Lezioni di Musica in soli{' '}
          <span className="italic text-grape" data-id="element-132" data-mp="3o6arg04e8f22">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl text-[15px] leading-snug text-navy/60 sm:mt-6 sm:text-lg sm:leading-relaxed" data-id="element-133" data-mp="39b4l1c1dye87">
          <span className="sm:hidden" data-id="element-134" data-mp="359t03jtgih6c">
            8 volumi PDF pronti all&apos;uso, dalla 1ª Primaria alla 3ª Media.
            Stampa, apri e insegna.
          </span>
          <span className="hidden sm:inline" data-id="element-135" data-mp="2violil7p0yc1">
            Musica Pronta è il sistema completo «chiavi in mano»: 8 volumi PDF
            pronti all&apos;uso carichi di teoria visuale, attività pratiche e
            verifiche dalla 1ª Primaria alla 3ª Media. Basta stampare, aprire e
            insegnare.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="mx-auto mt-3 max-w-2xl sm:mt-10" data-id="element-136" data-mp="s2tbjfzvhzn3">
          <img src="https://cdn.magicpatterns.com/uploads/eCgLYyLyYPWkbtr31z4f23/5c0bf463-2ccb-45c3-8536-7a7cb6333f55-2.webp" alt="Il pacchetto Musica Pronta: 8 volumi stampati, la versione digitale su computer, tablet e telefono e i 5 bonus" className="mx-auto max-h-[34vh] w-full object-contain sm:max-h-none" data-id="element-137" data-mp="dd592bfyguxs" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: 'easeOut'
      }} className="mt-3 sm:mt-8" data-id="element-138" data-mp="114kispa2aej2">
          <CtaButton href="#offerta" data-id="element-139" data-mp="3hrlm2muo2fb3" />
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] font-semibold text-navy/55 sm:mt-5 sm:gap-x-3 sm:gap-y-2 sm:text-xs" data-id="element-140" data-mp="3hqka8g5ttosb">
            {heroGuarantees.map((item, index) => <li key={item} className="flex items-center gap-2 sm:gap-3" data-id="element-141" data-mp="21b62nubgeul2" data-mpi={index}>
                <span data-id="element-142" data-mp="2697m4gcskvx2">
                  <span aria-hidden="true" className="text-teal" data-id="element-143" data-mp="268obzltdvbtl">
                    ✓{' '}
                  </span>
                  {item}
                </span>
                {index < heroGuarantees.length - 1 && <span aria-hidden="true" className="text-navy/25" data-id="element-144" data-mp="2kyvolkwpm0md">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}